// Scanned documents space and case tax numbers freely, so they are compared without either.
export const getNormalizedImportedInvoiceTaxNumber = (taxNumber?: string | null): string | undefined =>
  taxNumber?.replace(/\s/g, '').toUpperCase() || undefined
